// no baseURI

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
var installedChunks = {
	6998: 0,
	9072: 0,
	7889: 0,
	8463: 0,
	5010: 0,
	3374: 0,
	1147: 0,
	4463: 0,
	6590: 0,
	9835: 0,
	1179: 0,
	6046: 0,
	1694: 0,
	215: 0,
	7709: 0,
	1990: 0,
	6906: 0,
	528: 0,
	8079: 0,
	3647: 0,
	1010: 0,
	8783: 0,
	6075: 0,
	9554: 0,
	4831: 0,
	707: 0,
	1758: 0,
	3167: 0,
	4057: 0,
	6894: 0,
	2327: 0,
	1468: 0,
	8879: 0,
	189: 0,
	8233: 0,
	5265: 0,
	8627: 0,
	2948: 0,
	4384: 0,
	4995: 0,
	3037: 0,
	6010: 0,
	9916: 0,
	2055: 0,
	7004: 0,
	9730: 0
};

// no chunk on demand loading

// no prefetching

// no preloaded

// no HMR

// no HMR manifest

__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);

// install a JSONP callback for chunk loading
var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
	var [chunkIds, moreModules, runtime] = data;
	// add "moreModules" to the modules object,
	// then flag all "chunkIds" as loaded and fire callback
	var moduleId, chunkId, i = 0;
	if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
		for(moduleId in moreModules) {
			if(__webpack_require__.o(moreModules, moduleId)) {
				__webpack_require__.m[moduleId] = moreModules[moduleId];
			}
		}
		if(runtime) var result = runtime(__webpack_require__);
	}
	if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
	for(;i < chunkIds.length; i++) {
		chunkId = chunkIds[i];
		if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
			installedChunks[chunkId][0]();
		}
		installedChunks[chunkId] = 0;
	}
	return __webpack_require__.O(result);
}

var chunkLoadingGlobal = globalThis["webpackChunkvortexsolution"] = globalThis["webpackChunkvortexsolution"] || [];
chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));